import { noop } from "@common/helpers/function";
import { InvoiceStatus as InvoiceStatusEnum } from "@common/types/invoice";
import { InvoiceStatus } from "../../../../invoices/InvoiceStatus";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { BaseFilterProps, defaultInvoiceStatuses } from "../../lib";

export const InvoiceStatusFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const options: FilterMultiselectOption[] = Object.values(
        InvoiceStatusEnum,
    ).map((status) => ({
        value: status,
        label: <InvoiceStatus status={status} showText />,
        searchableLabel: status,
    }));

    const statuses =
        filters.invoiceStatuses && filters.invoiceStatuses.length > 0
            ? filters.invoiceStatuses
            : defaultInvoiceStatuses;

    return (
        <FilterMultiselect
            inDropdown={false}
            searchable={false}
            options={options}
            value={statuses}
            onChange={(val) => {
                onChange({ invoiceStatuses: val as InvoiceStatusEnum[] });
            }}
            name="invoiceStatuses"
            onBlur={noop}
        />
    );
};
